import { ChangeDetectionStrategy, Component, WritableSignal, computed, input } from '@angular/core';
import { ReactWrapperComponent } from '../react-wrapper/react-wrapper.component';
import { AddIdentity, AvailableInputStates } from '@startuptools/business-ui/identity/add/AddIdentity';
import { DetailState } from '@startuptools/business-ui/identity/types';
import { GqlIdentityQuery } from '../../graphql/operations';
import { JuridicalKind } from '../../models/identity.model';
import { ComponentProps, ReactNode } from 'react';
import { Relations } from '@startuptools/business-ui/identity/add/InputSystem';
import { GqlCreateIdentityInput } from '../../graphql/base-types.graphql';

export interface AddIdentityDialogSettings {
  headline: ReactNode;
  juridicalKinds: JuridicalKind[];
  availableInputStates: Partial<AvailableInputStates>;
  companyBoardOrgNumber?: string;
  identityExcludeList?: GqlIdentityQuery['identity'][];
  detailFieldsSettings?: {
    email?: DetailState;
    phone?: DetailState;
    address?: DetailState;
    countryCode?: DetailState;
  };
  relations?: Relations;
  handleCreate: (identity: GqlCreateIdentityInput) => Promise<unknown>;
}

@Component({
  imports: [ReactWrapperComponent],
  selector: 'app-add-identity-wrapper',
  template: `
    @if (openSignal()) {
      <app-react-wrapper [component]="AddIdentity" [props]="props()" [companyId]="companyId()" />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddIdentityWrapperComponent {
  AddIdentity = AddIdentity;

  openSignal = input.required<WritableSignal<boolean>>();
  settings = input.required<AddIdentityDialogSettings>();
  companyId = input.required<string>();

  props = computed(
    () =>
      ({
        ...this.settings(),
        onClose: () => this.openSignal().set(false),
      }) satisfies ComponentProps<typeof AddIdentity>,
  );
}
